_getFingerprint